module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai201-b09c45a5fdeb47cac64ad134729e4cb5.jpg";